import _find from 'lodash/find'
import _has from 'lodash/has'
import _keys from 'lodash/keys'
import _orderBy from 'lodash/orderBy'
import _round from 'lodash/round'

export const ga = {
  data () {
    return {
      deviceTypes: null,
      referrers: null,
      trafficMediums: null,
      visitors: null,
      visitorTypes: null
    }
  },
  methods: {
    getDeviceTypes (data, metric) {
      let deviceTypes = {
        desktop: 0,
        tablet: 0,
        mobile: 0
      }

      if (data) {
        let dimension = this.findMetric(data, 'dimensions', 'device_types')
        if (dimension) {
          for (let type of dimension.values) {
            let activeUsers = _find(type.values, {'field': metric})
            if (activeUsers) {
              deviceTypes[type.label.toLowerCase()] = activeUsers.value
            }
          }
        }
      }

      return deviceTypes
    },
    getRealtimeVisitors (data) {
      if (data) {
        return this.findMetric(data, 'metrics', 'active_users').value
      }
      return 0
    },
    getRealtimeVisitorTypes (data) {
      let visitorTypes = {
        new: 0,
        returning: 0
      }

      if (data) {
        let dimension = this.findMetric(data, 'dimensions', 'visitor_types')
        if (dimension) {
          for (let type of dimension.values) {
            let activeUsers = _find(type.values, {'field': 'active_users'})
            if (activeUsers) {
              visitorTypes[type.label.toLowerCase()] = activeUsers.value
            }
          }
        }
      }

      return visitorTypes
    },
    getReferrers (data) {
      let referrers = null

      if (data) {
        let dimension = this.findMetric(data, 'dimensions', 'referrers')
        if (dimension) {
          if (dimension.values.length > 0) {
            referrers = []
          }
          for (let type of dimension.values) {
            let visits = _find(type.values, {'field': 'visits'})
            if (visits) {
              referrers.push({
                label: type.label,
                value: visits.value
              })
            }
          }
        }
      }

      return _orderBy(referrers, ['value'], ['desc'])
    },
    getTrafficMediums (data) {
      let trafficMediums = {
        search: 0,
        email: 0,
        social: 0,
        paid: 0
      }

      if (data) {
        let dimension = this.findMetric(data, 'dimensions', 'traffic_mediums')
        if (dimension) {
          for (let medium of dimension.values) {
            let label = medium.label.toLowerCase()
            let activeUsers = _find(medium.values, {'field': 'active_users'})
            if (activeUsers) {
              if (_has(trafficMediums, label)) {
                trafficMediums[label] += activeUsers.value
              } else if (label === 'ppc') {
                trafficMediums.paid += activeUsers.value
              } else {
                trafficMediums.search += activeUsers.value
              }
            }
          }
        }
      }

      return trafficMediums
    },
    getVisitors (data) {
      if (data) {
        return this.findMetric(data, 'metrics', 'total_users').value
      }
      return 0
    },
    getVisitorTypes (data) {
      let visitorTypes = {
        total: 0,
        new: 0,
        returning: 0
      }

      if (data) {
        for (let type of _keys(visitorTypes)) {
          let value = this.findMetric(data, 'metrics', `${type}_users`).value
          visitorTypes[type] = value
        }
      }

      return visitorTypes
    },
    findMetric (data, category, name) {
      let metricValues = _find(data, {'field': category}).values
      return _find(metricValues, {'field': name})
    },
    visitorPercentage (count) {
      if (this.visitors < 1) return 0
      return _round((count / this.visitors) * 100)
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/mixins/ga.js